import { GetterTree } from "vuex";

import { DashboardState } from ".";
import { RootState } from "../root";

export default {
  loading: state => state.loading,
  retrieved: state => state.retrieved,
} as GetterTree<DashboardState, RootState>;
